import {Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[appHover]',
})
export class HoverDirective {

  viewChanged = false;

  constructor() {
  }

  @HostListener('mouseover', ['$event'])
  onMouseEnter(event: Event) {
    const thisElement = event.currentTarget as HTMLElement;
    const bodyRect = document.body.getBoundingClientRect();
    const rect = thisElement.getBoundingClientRect();
    const hoverDiv = document.getElementById('hover-div') as HTMLElement;
    hoverDiv.style.top = rect.top - bodyRect.top + 'px';
    hoverDiv.style.height = rect.height - 4 + 'px';
    hoverDiv.style.display = 'block';
  }

}
